import { makeStyles } from '@material-ui/styles';
import { Skeleton } from '@bizzabo/design-system';

const InvitationLoader: React.FC = () => {
    const classes = useStyles();

    return (
        <>
            <Skeleton className={classes.title} />
            <div className={classes.row}>
                <Skeleton className={classes.avatar} />
                <div className={classes.detailsContainer}>
                    <Skeleton className={classes.userDetails} />
                    <Skeleton className={classes.userDetails} />
                </div>
            </div>
            <Skeleton className={classes.text} />
            <Skeleton className={classes.text} />
            <Skeleton className={classes.boldText} />
            <Skeleton className={classes.boldText} />
            <div className={classes.daysContainer}>
                <Skeleton className={classes.day} />
                <Skeleton className={classes.day} />
                <Skeleton className={classes.day} />
            </div>
            <Skeleton className={classes.time} />
            <Skeleton className={classes.time} />
            <Skeleton className={classes.time} />
            <Skeleton className={classes.time} />
        </>
    );
};

const useStyles = makeStyles(
    () => ({
        title: {
            height: 30,
            marginTop: 40,
            marginBottom: 30,
        },
        row: {
            display: 'flex',
            marginBottom: 10,
        },
        avatar: {
            width: 40,
            height: 40,
            borderRadius: '50%',
        },
        detailsContainer: {
            flex: 1,
            marginLeft: 10,
        },
        userDetails: {
            height: 16,
            marginBottom: 6,
        },
        text: {
            marginBottom: 6,
        },
        boldText: {
            width: '90%',
            height: 20,
            marginTop: 10,
        },
        daysContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            margin: '20px 0 12px',
        },
        day: {
            width: '31%',
            height: 28,
        },
        time: {
            height: 48,
            marginBottom: 8,
        },
    }),
    { classNamePrefix: 'meetings-meeting-invitation-loader' }
);

export default InvitationLoader;
